import React from 'react'
import PackageMaster from './PackageMaster'

function Packages() {
  return <PackageMaster />
}

export default Packages
